<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="contactForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="mtma-contact-add-input-name"
							formControlName="Name" [disabled]="true" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'NAME' | translate }}" maxlength="40" />
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Rule, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Rule, 'label')">{{ 'GROUP' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Rule, 'borderInput')">
						<p-dropdown [options]="listRules" optionLabel="Name" [ngClass]="dynamicInputTextWidth()"
							appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 text"
							panelStyleClass="text-center" formControlName="Rule" placeholder="{{ 'GROUP' | translate }}"
							optionValue="Id" dataKey="Id">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Rule)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<p-panel header="{{ 'TEMPORARY_FROM'  | translate }}"
				*ngIf="!(contactForm.value.Rule === null || contactForm.value.Rule === undefined)" class="col-12"
				styleClass="p-panel-whitebg">
				<div class="grid">
					<div [ngClass]="col12Responsive()">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.f.StartDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.StartDate, 'label')">{{ 'START_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.StartDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon" formControlName="StartDate" appendTo="body"
									placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
									[ngClass]="dynamicInputTextDesktopTabletWidth()"
									[styleClass]="dynamicInputTextDesktopTabletWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.StartDate)" class="flex align-items-center text-50 pt-1"
							[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col12Responsive()">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.f.StartTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.StartTime, 'label')">{{ 'START_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.StartTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon" formControlName="StartTime" appendTo="body"
									timeOnly="true" [ngClass]="dynamicInputTextDesktopTabletWidth()"
									[styleClass]="dynamicInputTextDesktopTabletWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.StartTime)" class="flex align-items-center text-50 pt-1"
							[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'TAG_DATE_WARNING_INVALID' |
							translate }}</small>
					</div>
				</div>
			</p-panel>
			<p-panel header="{{ 'TEMPORARY_TO'  | translate }}"
				*ngIf="!(contactForm.value.Rule === null || contactForm.value.Rule === undefined)" class="col-12 mt-3"
				styleClass="p-panel-whitebg">
				<div class="grid">
					<div [ngClass]="col12Responsive()">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.f.EndDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.EndDate, 'label')">{{ 'END_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.EndDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon" formControlName="EndDate" appendTo="body"
									placeholder="dd/mm/yyyy" [minDate]="contactForm.value.startDate" dateFormat="dd/mm/yy"
									[ngClass]="dynamicInputTextDesktopTabletWidth()"
									[styleClass]="dynamicInputTextDesktopTabletWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<!-- <small *ngIf="showErrorRequiredMessage(this.f.EndDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'OVERALL_DATES_TIMES_REQUIRED' | translate }}</small> -->
					</div>
					<div [ngClass]="col12Responsive()">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(this.f.EndTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.EndTime, 'label')">{{ 'END_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(this.f.EndTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon" formControlName="EndTime" appendTo="body"
									timeOnly="true" [ngClass]="dynamicInputTextDesktopTabletWidth()"
									[styleClass]="dynamicInputTextDesktopTabletWidth()"
									inputStyleClass="pl-6 sm:pl-5 border-noround-right">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.EndTime)" class="flex align-items-center text-50 pt-1"
							[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'TAG_DATE_WARNING_INVALID' |
							translate }}</small>
					</div>
				</div>
			</p-panel>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>